import { Button, Layout, theme, Form, Input, Spin, Select, DatePicker, notification } from "antd";

import React, { useEffect, useCallback, useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import AllergensApi from "../../common/Apis/AllergensApi";
import IngredientsApi from "../../common/Apis/IngredientsApi";
import dayjs from "dayjs";
import ProductApi from "../../common/Apis/ProductApi";
import DepartmentDropdown from "../../common/DropDowns/Department";

const AddIngredients = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [Allergens, setAllergens] = React.useState([]);
  const getAllergens = useCallback(() => {
    AllergensApi.ListAllergensApi(0,100)
      .then((response) => {
        console.log(response);
        setAllergens(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [Products, setProducts] = React.useState([]);
  const getProducts = useCallback(() => {
    ProductApi.Listproducts()
      .then((response) => {
        setProducts(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [Departments, setDepartments] = React.useState([]);
  const getDepartments = useCallback(() => {
    DepartmentsApi.ListDepartments()
      .then((response) => {
        console.log(response);
        setDepartments(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getDepartments();
    getProducts();
    getAllergens();
  }, [getDepartments, getAllergens, getProducts]);

  const handleSubmit = (data) => {
    const SelectDate = dayjs(data.openUBD).format("DD/MM/YYYY");

    let formData = JSON.stringify({
      name: data.name,
      ingredientsStatus: data.status,
      batchCode: data.batchCode,
      openUBD: convertToUnixTimestamp(SelectDate),
      allergens: data?.allergens?.join("/"),
      allergensDTO: data?.allergens?.map(id => ({ id })),
      productDTO: {
        id: data.ProductId,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: data?.institutionId,
      },
    });
    IngredientsApi.CreateIngredients(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/ingredients");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };
  function convertToUnixTimestamp(dateString) {
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    const unixTimestamp = Date.UTC(year, month, day);
    return unixTimestamp;
  }
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="name"
                    label="Ingredients Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter name",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12}>
                  <Form.Item
                    name="status"
                    label="Status"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Status",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Status"
                    >
                      <option value="OPENED">Opened</option>
                      <option value="CLOSED">Closed</option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="batchCode"
                    label="Batch Code"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Batch Code",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Batch Code"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="openUBD"
                    label="Open UBD"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Open UBD",
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      className="form-control control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="allergens"
                    label="Allergens"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Allergens",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      className="control-Select mb-1"
                      placeholder="Select Allergen"
                    >
                      {Allergens && (
                        <>
                          {Allergens?.map((option, index) => (
                            <option key={index} value={option?.id}>
                              {option?.allergensName}
                            </option>
                          ))}
                        </>
                      )}
                    </Select>
                  </Form.Item>
                </Col>

                <Col lg={8} md={12}>
                  <Form.Item
                    name="ProductId"
                    label="Product"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Product",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1 "
                      placeholder="Select Product"
                    >
                      {Products && (
                        <>
                          {Products?.map((option, index) => (
                            <option key={index} value={option?.id}>
                              {option?.productName}
                            </option>
                          ))}
                        </>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <DepartmentDropdown />
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddIngredients;
